import { Navigate } from "react-router-dom"
import { controlAuditorsRoutes } from "@/pages/dashboard/control/auditors/routes.ts"
import { controlConsumersRoutes } from "@/pages/dashboard/control/consumers/routes.ts"
import { controlDictionaryRoutes } from "@/pages/dashboard/control/dictionaries/routes.ts"
import Control from "@/pages/dashboard/control/index.tsx"
import { controlOrganizationsRoutes } from "@/pages/dashboard/control/organizations/routes.ts"
import { controlRolesRoutes } from "@/pages/dashboard/control/roles/routes.ts"
import { controlStatisticsRoutes } from "@/pages/dashboard/control/statistics/routes.ts"
import { controlUsersRoutes } from "@/pages/dashboard/control/users/routes.ts"
import { BASE_ROLES } from "@/shared/constants"
import type { CustomRoute } from "@/shared/types"

export const controlRoutes: CustomRoute = {
  path: "control",
  handle: {
    label: "Управление",
    i18Key: "control",
    icon: "FilterVertical",
    ignoreChildren: true,
    allowedRoles: [BASE_ROLES.SUPER_ADMIN!, BASE_ROLES.REPUBLIC_INSPECTOR!]
  },
  element: <Control />,
  // onHover: () => {
  //   // Prefetching initial page assets
  //   import("@/pages/dashboard/control")
  //   queryClient.prefetchQuery({
  //     queryKey: ["organizations", 1, 30],
  //     queryFn: () => getOrganizations({ page_size: 30, page: 1 })
  //   })
  // },
  children: [
    {
      index: true,
      element: <Navigate to="statistics" replace />
    },
    controlStatisticsRoutes,
    controlOrganizationsRoutes,
    controlConsumersRoutes,
    controlAuditorsRoutes,
    controlUsersRoutes,
    controlRolesRoutes,
    controlDictionaryRoutes
  ]
}
